/**
 * Open Graph / WhatsApp require fully qualified https URLs for og:image.
 * Relative paths are ignored or break previews.
 */
export function toAbsoluteHttpUrl(url: string | undefined | null): string | undefined {
  const u = url?.trim()
  if (!u) return undefined
  if (/^https?:\/\//i.test(u)) return u
  if (u.startsWith("//")) return `https:${u}`
  if (typeof window === "undefined") return u
  const path = u.startsWith("/") ? u : `/${u}`
  return `${window.location.origin}${path}`
}
